import { render, staticRenderFns } from "./AttachedFile.vue?vue&type=template&id=b6de96e4&"
import script from "./AttachedFile.vue?vue&type=script&lang=ts&"
export * from "./AttachedFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports